import { Box, styled, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { getLmsName } from './LmsAuthSuccess';
import MainLayout from '../components/layout/MainLayout';
import { getUrlParams } from '../utils/url';

const StyledMainDiv = styled(Box)`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

const StyledTextDiv = styled(Box)`
    flex: 1;
    padding-top: 40px;
    padding-bottom: 12px;
`;

export const LmsAuthError = () => {
    const { ready, t } = useTranslation('lms_sync');
    const { lms_type: lmsType, error } = getUrlParams();

    if (ready) {
        return (
            <MainLayout title={t('lms-auth-title')}>
                <StyledMainDiv>
                    <StyledTextDiv>
                        <Typography variant="h3" data-testid="authResult">
                            {t('lms-auth-error')}
                        </Typography>
                    </StyledTextDiv>
                    <Typography>{t('lms-auth-error-directions', { lmsName: getLmsName(t, lmsType) })}</Typography>
                    {error && (
                        <>
                            <StyledTextDiv>
                                <Typography variant="h5">{t('lms-auth-error-details')}</Typography>
                            </StyledTextDiv>
                            <Typography variant="body2">{t(error)}</Typography>
                        </>
                    )}
                </StyledMainDiv>
            </MainLayout>
        );
    }

    return null;
};

export default LmsAuthError;
